import { render, staticRenderFns } from "./SessionNotesModal.vue?vue&type=template&id=27092f1c&scoped=true&"
import script from "./SessionNotesModal.vue?vue&type=script&lang=js&"
export * from "./SessionNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27092f1c",
  null
  
)

export default component.exports